export const baseUrl = "https://app.agriyields.com:8443/api/";//"http://localhost:8443/api/";
export const mapBaseUrl = "http://188.166.125.28:5000/api/soilDataMap";




